@if (isCustom()) {
  <mat-icon class="capability-icon" [matTooltip]="'Custom'">auto_awesome</mat-icon>
} @else if (productIcon()?.matIcon) {
  <div class="product-icon-circle" [matTooltip]="productIcon()!.productName">
    <mat-icon class="product-mat-icon">{{ productIcon()!.matIcon }}</mat-icon>
  </div>
} @else if (productIcon()?.iconUrl) {
  <glxy-avatar [src]="productIcon()!.iconUrl" [width]="24" [matTooltip]="productIcon()!.productName"></glxy-avatar>
} @else {
  <div class="product-icon-circle" [matTooltip]="'AI_ASSISTANT.CAPABILITIES.SCOPE.BUILT_IN' | translate">
    <mat-icon class="product-mat-icon">auto_awesome</mat-icon>
  </div>
}
